import React from 'react'
import {BuyersCrop, DisclosuresCrop, OffersCrop, StudioCrop} from './FeatureCrops'

const features = [
  {
    title: 'Disclosures, packaged and shared',
    body:
      "Fill seller forms, collect signatures with DocuSign, and share one secure link with buyer parties. The AI summary flags what matters, so you're ready for any question.",
    Crop: DisclosuresCrop,
  },
  {
    title: 'See which buyers are serious',
    body:
      "Track every view, download, and return visit across your listing. Engagement scoring ranks each buyer party by how closely they're looking, so you know who to call first.",
    Crop: BuyersCrop,
  },
  {
    title: 'Accept offers in one secure place and compare them side by side',
    body:
      'Offer intelligence checks every submission for completeness, compares terms and contingencies, flags risks, and shows the net to your seller for each offer. All in one simple dashboard.',
    Crop: OffersCrop,
  },
  {
    title: 'Create on-brand listing marketing in minutes',
    comingSoon: true,
    body:
      'Listing Studio turns the photos and details already in HLM into a property website, flyers, and social posts you can schedule in advance. No design tools needed.',
    Crop: StudioCrop,
  },
]

function FeaturesV2() {
  return (
    <section id="features" className="hlm-features">
      <div className="hlm-container">
        <div className="hlm-section-intro">
          <h2>Everything a listing needs, with real buyer insights to move with confidence.</h2>
          <p className="hlm-section-lede">
            One platform that replaces the inbox, the shared drive, the spreadsheet, the PDF editor, and the design tool.
          </p>
        </div>
        <div className="hlm-feature-grid">
          {features.map(feature => (
            <article className="hlm-feature-card" key={feature.title}>
              <h3>
                {feature.title}
                {feature.comingSoon ? <span className="hlm-coming-soon">COMING SOON</span> : null}
              </h3>
              <p>{feature.body}</p>
              <feature.Crop />
            </article>
          ))}
        </div>
      </div>
    </section>
  )
}

export default FeaturesV2
